// QuickBooks SVG icon
import React from 'react';

const QBIcon = ({ width = 20, height = 20, className = '', alt = 'QuickBooks' }) => {
  const src = `/QB.svg`;

  return (
    <img src={src} alt={alt} width={width} height={height} className={className} loading="lazy" decoding="async" />
  );
};

export default QBIcon;
